import { useState } from "react";
import useFetchFullStandard from "../../../hooks/useFetchFullStandard";
import { TableLoader } from "../../../components/Loader";
import { GetRole } from "../../../utils/RolesandAccess";
import CreateOrUpdate from "./form";

function SubcriptionIndex() {
  const [showMyModal, setShowMyModal] = useState(false);
  const handleOnClose = () => setShowMyModal(false);
  const [standardId, setStandardId] = useState("");
  const {standardFullList,isLoading,getAllStandard} = useFetchFullStandard()

  function handleChange(e, id) {
    setStandardId(id);
    if (e.target.checked) {
      setShowMyModal(true);
    }
  }

  return (
    <>
      <div className=" w-full h-[calc(100vh-140px)] overflow-y-auto">
        <div className="pb-2 px-2 flex justify-between items-center w-full">
          <h4 className="text-sm 2xl:text-base font-medium text-heading">
           Standard Subscription
          </h4>
        </div>
        <div className=" w-full h-[calc(100vh-180px)] text-left relative overflow-y-auto">
          <div className=" sticky top-0 z-10">
            <table className="table-auto w-full">
              <thead className="bg-tabletitle">
                <tr className="flex items-center text-xs 2xl:text-sm font-medium">
                  {header?.map((header) => (
                    <th className={`${header.align} py-4 ${header.width}`}>
                      {header?.headone}
                    </th>
                  ))}
                </tr>
              </thead>
            </table>
          </div>
          <div>
            <table className="table-auto w-full">
              {isLoading == true ? (
                <>
                  {[...Array(10)].map((_, index) => {
                    return <TableLoader key={index} header={header} />;
                  })}
                </> 
              ) : (
                <>
                  {standardFullList &&
                    standardFullList.map((data, i) => (
                      <tr
                        className="odd:bg-tableodd w-full even:bg-tableeven text-xs 2xl:text-sm py-1 flex justify-between items-center my-1"
                        key={i}
                      >
                        <td
                          className={`text-center text-gray-900 py-1 w-[10%]`}
                        >
                          {i + 1}
                        </td>
                        <td
                          className={`text-left text-gray-900 py-1 w-[70%]`}
                        >
                          {data.name || "-"}
                        </td>
                        <td className={`text-center text-gray-900 py-1 w-[20%]`}>
                          <div className=" w-full h-full flex justify-center items-center">
                          {GetRole()&&
                          <input
                          class="mr-2 mt-[0.3rem] h-3.5 w-8 appearance-none rounded-[0.4375rem] bg-neutral-300 before:pointer-events-none before:absolute before:h-3.5 before:w-3.5 before:rounded-full before:bg-transparent before:content-[''] after:absolute after:z-[2] after:-mt-[0.1875rem] after:h-5 after:w-5 after:rounded-full after:border-none after:bg-neutral-100 after:shadow-[0_0px_3px_0_rgb(0_0_0_/_7%),_0_2px_2px_0_rgb(0_0_0_/_4%)] after:transition-[background-color_0.2s,transform_0.2s] after:content-[''] checked:bg-primary checked:after:absolute checked:after:z-[2] checked:after:-mt-[3px] checked:after:ml-[1.0625rem] checked:after:h-5 checked:after:w-5 checked:after:rounded-full checked:after:border-none checked:after:bg-primary checked:after:shadow-[0_3px_1px_-2px_rgba(0,0,0,0.2),_0_2px_2px_0_rgba(0,0,0,0.14),_0_1px_5px_0_rgba(0,0,0,0.12)] checked:after:transition-[background-color_0.2s,transform_0.2s] checked:after:content-[''] hover:cursor-pointer focus:outline-none focus:ring-0 focus:before:scale-100 focus:before:opacity-[0.12] focus:before:shadow-[3px_-1px_0px_13px_rgba(0,0,0,0.6)] focus:before:transition-[box-shadow_0.2s,transform_0.2s] focus:after:absolute focus:after:z-[1] focus:after:block focus:after:h-5 focus:after:w-5 focus:after:rounded-full focus:after:content-[''] checked:focus:border-primary checked:focus:bg-primary checked:focus:before:ml-[1.0625rem] checked:focus:before:scale-100 checked:focus:before:shadow-[3px_-1px_0px_13px_#3b71ca] checked:focus:before:transition-[box-shadow_0.2s,transform_0.2s] dark:bg-neutral-600 dark:after:bg-neutral-400 dark:checked:bg-primary dark:checked:after:bg-primary dark:focus:before:shadow-[3px_-1px_0px_13px_rgba(255,255,255,0.4)] dark:checked:focus:before:shadow-[3px_-1px_0px_13px_#3b71ca]"
                          type="checkbox"
                          checked={data?.isActive && data?.keyActivated}
                          onChange={(e) => handleChange(e, data?.id)}
                          role="switch"
                          id="flexSwitchCheckDefault"
                        />
                        }
                          </div>
                        </td>
                      </tr>
                    ))}
                </>
              )}
            </table>
          </div>
        </div>
      </div>
      <CreateOrUpdate
        onClose={handleOnClose}
        visible={showMyModal}
        refreshData={getAllStandard}
        id={standardId}
      />
    </>
  );
}

export default SubcriptionIndex;

const header = [
  {
    headone: "SI. No",
    width: "w-[10%]",
    align: "text-center",
  },
  {
    headone: "Standard Name",
    width: "w-[70%]",
    align: "text-left",
  },
  {
    headone: "Subscription Status",
    width: "w-[20%]",
    align: "text-center",
  },
];
